import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useBoolean } from 'usehooks-ts';

import { SearchSelect } from '@/components/form/inputs/search-select';
import { UpdateTask } from '@/task-manager/api/mutations/update-task';
import { ListUsers } from '@/task-manager/api/queries/list-users';
import type { TaskDetails } from '@/task-manager/entities/task-details';
import type { TaskUser } from '@/task-manager/entities/task-user';

import { AddUserDialog } from '../../add-user-dialog';
import { TaskAttribute } from '../task-attribute';

export type TaskUpdateAssigneeProps = {
  task: TaskDetails;
};

export function TaskUpdateAssignee({ task }: TaskUpdateAssigneeProps) {
  const users = ListUsers.useQuery();
  const updateTask = UpdateTask.useMutation();
  const isAddDialogOpen = useBoolean();

  return (
    <>
      <TaskAttribute label="Assignee">
        <SearchSelect<TaskUser | undefined>
          additionalAction={{
            label: 'Add a user\u2026',
            leftIcon: <PlusIcon />,
            onClick: () => isAddDialogOpen.setTrue(),
          }}
          value={task.assignee}
          placeholder="Select a user"
          options={users.data ? [undefined, ...users.data.users] : []}
          renderValue={(user) => user?.name ?? ''}
          renderOption={(user) =>
            user?.name ?? <MinusIcon className="size-4 text-gray-400" />
          }
          optionKey={(user) => user?.email ?? '__none__'}
          searchBy={(user, query) =>
            user ? user.name.toLowerCase().includes(query.toLowerCase()) : false
          }
          onSelect={(assignee) =>
            updateTask.mutate({
              id: task.id,
              assignee: assignee ?? null,
            })
          }
          loading={updateTask.isLoading}
        />
      </TaskAttribute>
      <AddUserDialog
        open={isAddDialogOpen.value}
        onClose={function (assignee?: TaskUser) {
          if (assignee) {
            updateTask.mutate({ id: task.id, assignee });
          }

          isAddDialogOpen.setFalse();
        }}
      />
    </>
  );
}
